import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastrServiceManager {
  constructor(private toastr: ToastrService) {}

  showSuccess(text: string, title: string = 'Parabéns!') {
    this.toastr.success(text, title);
  }

  showError(text: string, title: string = 'Algo deu errado 🙁') {
    this.toastr.error(text, title);
  }

  showWarning(text: string, title: string = 'Atenção!') {
    this.toastr.warning(text, title);
  }

  showInfo(text: string, title: string = 'Informação') {
    this.toastr.info(text, title);
  }
}
